import $ from 'jquery';

const contentSlideEffect = () => {
  const init = () => {
    slideEffect();
    slideEffectPole();

  };

  const slideEffect = () => {
    const elements = {
      geschiedenis: '.geschiedenis-timeline',
      timelineBlock: '.timeline-block',
      hiddenClass: 'timeline-block-hidden',
    };

    const observerOptions = {
      threshold: 0.9,
    };

    const timelineBlocks = document.querySelectorAll(elements.timelineBlock);

    if ($(elements.geschiedenis).length === 0) return;

    const intersectionCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.remove(elements.hiddenClass);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(intersectionCallback, observerOptions);

    timelineBlocks.forEach((block) => {
      observer.observe(block);
    });
  };

  const slideEffectPole = () => {
    const elements = {
      entryContent: '.entry-content',
    };

    const entryChildren = $(elements.entryContent).children(':not(:first-child)');
    // const entryChildren = $(elements.entryContent).find('[class^="section-content-"]').not(':first-child').children();
    const isNewsArchive = $(elements.entryContent).closest('section-content-news-archive');

    const hiddenClass = 'section-content-hidden';

    entryChildren.addClass(hiddenClass);
  
    const observerOptions = {
      threshold: isNewsArchive ? 0.1 : 0.9, 
    };

    if ($(elements.entryContent).length === 0) return;
  
    const intersectionCallback = (entries, observer) => {
      entries.forEach((entry) => {

        if (entry.isIntersecting) {
          $(entry.target).removeClass(hiddenClass);
          observer.unobserve(entry.target);
        }
      });
    };
    const observer = new IntersectionObserver(intersectionCallback, observerOptions);
  
    entryChildren.each((index, block) => {
      observer.observe(block);
    });
  };

  init();
};

try {
  contentSlideEffect();
} catch (error) {
    // eslint-disable-next-line no-console
  console.error(error);
}
